export default "__VITE_ASSET__Df0nihL0__"